import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { gql, ResultOf } from '@/utilities/gql';
import { DEMO_PORTFOLIO_ID } from '@/constants';

export const PORTFOLIO_ANALYSIS_FRAGMENT = gql(`
  fragment portfolioDividendAnalysisFields on Portfolio @_unmask{
    id
    analysis {
      estimatedDividendYield
      estimatedYearlyDividendFuture1y
      estimatedYearlyDividendYieldOnCapitalInvested
      estimatedYearlyDividendPast1y
      dividendPayingHoldingsCount
    }
  }
`);

const QUERY = gql(
  `
  query getPortfolioDividendAnalysis($portfolioId: String!) {
    Portfolio(id: $portfolioId) {
      ...portfolioDividendAnalysisFields
    }
  }
`,
  [PORTFOLIO_ANALYSIS_FRAGMENT]
);

const QUERY_FOR_DEMO = gql(
  `
  query getDemoPortfolioDividendAnalysis($portfolioId: String!) {
    samplePortfolio(id: $portfolioId) {
      ...portfolioDividendAnalysisFields
    }
  }
`,
  [PORTFOLIO_ANALYSIS_FRAGMENT]
);

type HookParams = {
  portfolioId: string;
};

export const usePortfolioDividendCreator =
  (currencyISO: string) =>
  ({ portfolioId }: HookParams) => {
    const isDemo = portfolioId === DEMO_PORTFOLIO_ID;

    if (isDemo) {
      return makeGqlSuspenseQuery(QUERY_FOR_DEMO, {
        queryKey: ['getDemoPortfolioDividendAnalysis', currencyISO],
      })({ portfolioId });
    }

    return makeGqlSuspenseQuery(QUERY, {
      queryKey: ['getPortfolioDividendAnalysis', currencyISO],
    })({ portfolioId });
  };

export type UserPortfolioDividendDataRaw = ResultOf<typeof QUERY>;
export type DemoPortfolioDividendDataRaw = ResultOf<typeof QUERY_FOR_DEMO>;
export type PortfolioDividendDataRaw =
  | UserPortfolioDividendDataRaw
  | DemoPortfolioDividendDataRaw;
